import { useParams } from "react-router-dom";
import { useApi } from "@/lib/api";
import { RichContent } from "@/components/site/RichContent";
import { ShareMenu } from "@/components/site/ShareMenu";
import { BackLink, DetailSkeleton, NotFound } from "@/components/site/DetailBits";

export default function ArtistDetail() {
  const { slug } = useParams();
  const { data: a, isLoading, isError } = useApi(`/artists/${slug}`);
  if (isLoading) return <DetailSkeleton />;
  if (isError || !a) return <NotFound to="/artistes" label="Retour aux artistes" />;

  return (
    <article className="pt-32 pb-32" data-testid="artist-detail">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <BackLink to="/artistes" label="Retour aux artistes" />
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20 mt-10">
          <div className="lg:sticky lg:top-28 self-start overflow-hidden bg-[hsl(var(--surface))]">
            {a.image && <img src={a.image} alt={a.name} className="w-full h-auto reveal" />}
          </div>
          <div className="reveal" style={{ animationDelay: "120ms" }}>
            {a.tags?.length > 0 && <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">{a.tags.join(" · ")}</p>}
            <h1 className="font-display uppercase text-5xl sm:text-6xl lg:text-8xl leading-[0.92] text-white mt-3 break-words" data-testid="artist-detail-name">{a.name}</h1>
            <div className="mt-8">
              <ShareMenu text={`${a.name} sur LGTDZ`} testId="artist-share" label="Partager"
                className="border border-white/30 text-white uppercase text-xs font-bold tracking-[0.2em] px-5 py-3 hover:border-white" />
            </div>
            <div className="mt-12">
              <RichContent content={a.content} fallback={a.excerpt} embeds={a.embeds} />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
